import { render, staticRenderFns } from "./ElectronSetting.vue?vue&type=template&id=08627d54&"
import script from "./ElectronSetting.vue?vue&type=script&lang=js&"
export * from "./ElectronSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports